import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Layout from './components/Layout.jsx'
import ScrollToTop from './components/ScrollToTop.jsx'
import Analytics from './components/Analytics.jsx'
import App from './App.jsx'
import ForeignDTCBrands from './pages/ForeignDTCBrands.jsx'
import AmericasGoingGlobal from './pages/AmericasGoingGlobal.jsx'
import ManufacturersDTC from './pages/ManufacturersDTC.jsx'
import MarketUS from './pages/MarketUS.jsx'
import MarketCanada from './pages/MarketCanada.jsx'
import MarketLATAM from './pages/MarketLATAM.jsx'
import MarketIndia from './pages/MarketIndia.jsx'
import Blog from './pages/Blog.jsx'
import BigBoxRetail from './pages/solutions/BigBoxRetail.jsx'
import TradeShows from './pages/solutions/TradeShows.jsx'
import MarketCenters from './pages/solutions/MarketCenters.jsx'
import OnlineSales from './pages/solutions/OnlineSales.jsx'
import ProductMarketFit from './pages/solutions/ProductMarketFit.jsx'
import NewMarketEntry from './pages/solutions/NewMarketEntry.jsx'
import BoutiqueRetail from './pages/solutions/BoutiqueRetail.jsx'
import NativeBranding from './pages/solutions/NativeBranding.jsx'
import InfluencerMarketing from './pages/solutions/InfluencerMarketing.jsx'
import SupplyChain from './pages/solutions/SupplyChain.jsx'
import TariffEngineering from './pages/solutions/TariffEngineering.jsx'
import B2BSales from './pages/solutions/B2BSales.jsx'
import ClusterMarketing from './pages/solutions/ClusterMarketing.jsx'
import SocialMedia from './pages/solutions/SocialMedia.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Analytics />
      <Layout>
        <Routes>
          <Route path="/" element={<App />} />
        <Route path="/foreign-dtc-americas" element={<ForeignDTCBrands />} />
        <Route path="/americas-global" element={<AmericasGoingGlobal />} />
        <Route path="/manufacturers-dtc" element={<ManufacturersDTC />} />
        <Route path="/market-us" element={<MarketUS />} />
        <Route path="/market-canada" element={<MarketCanada />} />
        <Route path="/market-latam" element={<MarketLATAM />} />
        <Route path="/market-india" element={<MarketIndia />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/solutions/big-box-retail" element={<BigBoxRetail />} />
        <Route path="/solutions/trade-shows" element={<TradeShows />} />
        <Route path="/solutions/market-centers" element={<MarketCenters />} />
        <Route path="/solutions/online-sales" element={<OnlineSales />} />
        <Route path="/solutions/product-market-fit" element={<ProductMarketFit />} />
        <Route path="/solutions/new-market-entry" element={<NewMarketEntry />} />
        <Route path="/solutions/boutique-retail" element={<BoutiqueRetail />} />
        <Route path="/solutions/native-branding" element={<NativeBranding />} />
        <Route path="/solutions/influencer-marketing" element={<InfluencerMarketing />} />
        <Route path="/solutions/supply-chain" element={<SupplyChain />} />
        <Route path="/solutions/tariff-engineering" element={<TariffEngineering />} />
        <Route path="/solutions/b2b-sales" element={<B2BSales />} />
        <Route path="/solutions/cluster-marketing" element={<ClusterMarketing />} />
        <Route path="/solutions/social-media" element={<SocialMedia />} />
      </Routes>
      </Layout>
    </BrowserRouter>
  </React.StrictMode>
)